import {
  API_GET_NB_KEEPERS_FOR_PUSH_NOTIFICATIONS,
  API_SEARCH_TEST_KEEPER,
  API_SEND_TEST_PUSH_NOTIFICATION,
  API_SEND_PUSH_NOTIFICATIONS,
  API_SEND_PUSH_NOTIFICATIONS_TO_KEEPER_IDS,
} from "actions/push-notifications"
import { FctServiceReturn } from "./services.types"

export function apiGetNbKeepersForPushNotifications({
  statuses,
  zipcodes,
}: {
  statuses: string
  zipcodes: string
}): FctServiceReturn<any> {
  return {
    type: API_GET_NB_KEEPERS_FOR_PUSH_NOTIFICATIONS,
    payload: {
      request: {
        url: `/admin/pushNotifications/nbKeepersAvailable`,
        params: {
          statuses,
          zipcodes,
        },
      },
    },
  }
}

export function apiSearchTestKeepers({ input }: { input: string }): FctServiceReturn<any> {
  return {
    type: API_SEARCH_TEST_KEEPER,
    payload: {
      request: {
        url: `/admin/pushNotifications/testKeeper`,
        params: {
          input,
        },
      },
    },
  }
}

export function apiSendTestPushNotification({
  keeperId,
  title,
  content,
  data,
}: {
  keeperId: string
  title: string
  content: string
  data: { redirectTo: string }
}): FctServiceReturn<any> {
  return {
    type: API_SEND_TEST_PUSH_NOTIFICATION,
    payload: {
      request: {
        method: "POST",
        url: `/admin/pushNotifications/sendTest`,
        data: {
          keeperId,
          title,
          content,
          data,
        },
      },
    },
  }
}

export function apiSendPushNotifications({
  statuses,
  zipcodes,
  title,
  content,
  data,
}: {
  statuses: string[]
  zipcodes: string[]
  title: string
  content: string
  data: { redirectTo: string }
}): FctServiceReturn<any> {
  return {
    type: API_SEND_PUSH_NOTIFICATIONS,
    payload: {
      request: {
        method: "POST",
        url: `/admin/pushNotifications/send`,
        data: {
          statuses,
          zipcodes,
          title,
          content,
          data,
        },
      },
    },
  }
}

export function apiSendPushNotificationsToKeeperIds({
  title,
  content,
  data,
  keeperIds,
}: {
  title: string
  content: string
  data: { redirectTo: string }
  keeperIds: string[]
}): FctServiceReturn<any> {
  return {
    type: API_SEND_PUSH_NOTIFICATIONS_TO_KEEPER_IDS,
    payload: {
      request: {
        method: "POST",
        url: `/admin/pushNotifications/sendToKeepersIDs`,
        data: {
          title,
          content,
          data,
          keeperIds,
        },
      },
    },
  }
}
